import { FormFieldProps, formFieldFactory } from '@eas/common-web';
import { TreeObject } from '@models';
import { LocalTree, LocalTreeProps } from './local-tree/local-tree';

export const FormLocalTree = formFieldFactory(LocalTree) as <
  OPTION extends TreeObject
>(
  props: FormFieldProps<LocalTreeProps<OPTION>>
) => JSX.Element;
